export enum STATUS_ITEM  {
  QUOTED = "QUOTED", 
  APPROVED = "APPROVED", 
  REJECTED = "REJECTED"
}

export type IItem = {
  id?: string;
  productId: string;
  productName: string;
  quantity: string;
  notes?: string;
  deliveryDate?: Date | null;
};

export enum PURCHASEREQUISITION_STATUS {
  IN_PROGRESS = "Em andamento",
  PENDING = "Pendente",
  CONFIRMED = "Confirmado",
  PENDING_NF = "Pendente de NF",
  APPROVED = "Aprovado",
  REJECTED = "Rejeitada",
}

export enum PURCHASEREQUISITION_SITUATION {
  PENDING = "PENDING",
  NOT_QUOTED = "NOT_QUOTED",
  PARTIAL_QUOTED = "PARTIAL_QUOTED",
  FULLY_QUOTED = "FULLY_QUOTED",
  PARTIAL_ORDERED = "PARTIAL_ORDERED",
  FULLY_ORDERED = "FULLY_ORDERED",
  PARTIAL_RECEIVED = "PARTIAL_RECEIVED",
  FULLY_RECEIVED = "FULLY_RECEIVED",
  CANCELED = "CANCELED",
  APPROVED = "APPROVED",
  PARTIAL_APPROVED = "PARTIAL_APPROVED",
  REJECTED = "REJECTED"
}

export const PURCHASEREQUISITION_SITUATION_LABELS = {
  "PENDING": "Pendente",
  "NOT_QUOTED" : "Não cotado",
  "PARTIAL_QUOTED": "Cotado parcialmente",
  "FULLY_QUOTED": "Cotado",
  // "PARTIAL_ORDERED": "PARTIAL_ORDERED",
  "FULLY_ORDERED": "FULLY_ORDERED",
  // "PARTIAL_RECEIVED": "PARTIAL_RECEIVED",
  // "FULLY_RECEIVED": "FULLY_RECEIVED",
  // "CANCELED": "CANCELED",
  "PARTIAL_APPROVED": "Aprovada parcialmente",
  "APPROVED": "Aprovado",
  "REJECTED": "Rejeitado"
}

export type IPurchaseRequisition = {
  [x: string]: unknown;
  _id: string;
  date: Date;
  requestorName: string;
  description: string;
  status: string;
  itens: IItem[];
  licensePlate?: string;
  observation?: string;
  priority?: string;
  billetFiles?: string;
};

export const emptyPurchaseRequisition = () =>
  ({
    _id: "",
    date: new Date(),
    requestorName: "",
    description: "",
    status: "",
    itens: [],
  } as IPurchaseRequisition);
